"use strict";
window._theme = window._theme || {};

_theme.KlarnaWidget = (function () {
  const selecotrs = {
    container: "klarna-placement",
    learnMoreBtn: 'button[part="osm-cta"]',
    modalCloseBtn: '#learn-more-dialog-payment_calculator-default__nav-bar__right-icon',
    modalCloseBtnWrapper: '#learn-more-dialog-payment_calculator-default__nav-bar__right-edge',
    modalHeader: '#learn-more-dialog-payment_calculator-default__nav-bar'
  };

  const KM_EVENT = {
    MODAL_OPENED_LEGACY:'informationalModalOpened', // For backward compatibility
    MODAL_CLOSED_LEGACY:'informationalModalClosed', // For backward compatibility
    PLACEMENT_RENDERED_LEGACY:'placementRendered', // For backward compatibility
    PLACEMENT_RENDERED: 'placement-rendered',
    MODAL_OPENED: 'informational-modal-opened',
    MODAL_CLOSED: 'informational-modal-closed',
  };

  function KlarnaWidget() {
    const wrapperInterval = setInterval(() => {
      if(!window.Klarna || !window.Klarna.OnsiteMessaging) return;
      clearInterval(wrapperInterval);
      this.init();
    }, 2000);

    setTimeout(() => {
      if (wrapperInterval) clearInterval(wrapperInterval);
    }, 15000);
  }
  
  KlarnaWidget.prototype.init = function () {
    if (!window.Klarna)  return;

    window.Klarna.OnsiteMessaging.on(KM_EVENT.PLACEMENT_RENDERED, evt => {
      if(!evt.element) return;
      const learnMoreBtn = evt.element.querySelector(selecotrs.learnMoreBtn);
      if(learnMoreBtn) learnMoreBtn.setAttribute("aria-label", "Learn More about Klarna interest free payments");
    });
    
    // window.Klarna.OnsiteMessaging.on(KM_EVENT.MODAL_OPENED, (evt) => {});
    // Klarna.OnsiteMessaging.on(KM_EVENT.MODAL_CLOSED, (evt) => {});
  };

  return KlarnaWidget;
})();

window.onload = function () {
  new _theme.KlarnaWidget();
};